import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from 'src/app/_services/dashboard.service';

export interface ExternalDeliveryKpiConfig {
  selectedTypes: string[];
  excludedDomains: string[];
}

@Component({
  selector: 'app-external-delivery-config-modal',
  templateUrl: './external-delivery-config-modal.component.html',
  styleUrls: ['./external-delivery-config-modal.component.css']
})
export class ExternalDeliveryConfigModalComponent implements OnInit {
  @Input() currentConfig: ExternalDeliveryKpiConfig = { selectedTypes: [], excludedDomains: [] };

  availableTypes: string[] = [];
  loadingTypes = true;
  selectedTypes: Set<string> = new Set();
  excludedDomains: string[] = [];
  newDomain = '';
  domainError = '';

  constructor(
    public activeModal: NgbActiveModal,
    private dashboardService: DashboardService
  ) {}

  ngOnInit() {
    this.selectedTypes = new Set(this.currentConfig.selectedTypes ?? []);
    this.excludedDomains = [...(this.currentConfig.excludedDomains ?? [])];

    this.dashboardService.getAlertSensitiveTypes().subscribe({
      next: res => {
        const all = res.body ?? [];
        this.availableTypes = [
          ...all.filter(t => this.selectedTypes.has(t)),
          ...all.filter(t => !this.selectedTypes.has(t)),
        ];
        this.loadingTypes = false;
      },
      error: () => { this.loadingTypes = false; }
    });
  }

  toggleType(name: string) {
    if (this.selectedTypes.has(name)) this.selectedTypes.delete(name);
    else this.selectedTypes.add(name);
  }

  isSelected(name: string): boolean {
    return this.selectedTypes.has(name);
  }

  clearTypes() { this.selectedTypes.clear(); }

  addDomain() {
    const domain = this.newDomain.trim().toLowerCase();
    if (!domain) return;
    if (!/^[\w.-]+\.[a-z]{2,}$/.test(domain)) {
      this.domainError = 'Formato inválido (ej: empresa.com)';
      return;
    }
    if (this.excludedDomains.includes(domain)) {
      this.domainError = 'El dominio ya está en la lista';
      return;
    }
    this.excludedDomains = [...this.excludedDomains, domain];
    this.newDomain = '';
    this.domainError = '';
  }

  removeDomain(domain: string) {
    this.excludedDomains = this.excludedDomains.filter(d => d !== domain);
  }

  onDomainKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') { event.preventDefault(); this.addDomain(); }
    else this.domainError = '';
  }

  get hasActiveFilters(): boolean {
    return this.selectedTypes.size > 0 || this.excludedDomains.length > 0;
  }

  apply() {
    this.activeModal.close({
      selectedTypes: Array.from(this.selectedTypes),
      excludedDomains: [...this.excludedDomains]
    } as ExternalDeliveryKpiConfig);
  }

  reset() {
    this.activeModal.close({ selectedTypes: [], excludedDomains: [] } as ExternalDeliveryKpiConfig);
  }

  dismiss() { this.activeModal.dismiss(); }
}
